module.exports = __webpack_public_path__ + "media/images/allcare-academy-bg-sp-5d5f97382561080167d43ae4efd5df0a.jpg";